import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IIkSelectPaymentPaiementProfileCard, IIkSelectPaymentPaiementProfilePrepaid, IIkSelectPaymentBillingAddress } from './invitation-b2b-client.interfaces';

export enum INVITATIONB2BCLIENTSTEPSTYPE {
  invitationB2bInit = 'initial',
  invitationB2bAccepted = 'accepted',
  invitationB2bRejected = 'rejected',
  invitationB2bAlreadyAccepted = 'already_accepted',
  invitationB2bAlreadyRejected = 'already_rejected',
  invitationB2bSelectAccount = 'select_account',
  invitationB2bWrongAccount = 'wrong_account',
  invitationB2bOnlyForOwners = 'only_for_owners',
  invitationB2bSelectPayment = 'select_payment_method',
}

export type TInvitationB2BClientSteps = typeof INVITATIONB2BCLIENTSTEPSTYPE[keyof typeof INVITATIONB2BCLIENTSTEPSTYPE];

@Injectable({
  providedIn: 'root'
})

export class InvitationB2bClientService {

  constructor(
    private http: HttpClient,
  ) { }

  acceptInvitation(customerAccount: number, fullAccess: boolean, hasCustomerPayment: boolean): Promise<any> {
    return this.http
      .post<any>(`/invitation/b2b/customer/accept`, {
        customer_account_id: customerAccount,
        full_access: fullAccess,
        has_customer_payment_method: hasCustomerPayment,
      })
      .toPromise();
  }

  rejectInvitation(customer_account_id: number): Promise<any> {
    return this.http
      .post<any>(`/invitation/b2b/customer/reject`, {
        customer_account_id
      })
      .toPromise();
  }

  resendInvitation(): Promise<any> {
    return this.http
      .post<any>(`/invitation/b2b/customer/resend`, {})
      .toPromise();
  }

  /**
* Get paiement profile info for account
* @returns IPublicCloudPaiementProfile[]
*/
  getPaiementProfile(accountId): Promise<Array<IIkSelectPaymentPaiementProfileCard | IIkSelectPaymentPaiementProfilePrepaid>> {
    return this.getPaiementProfileJSON(accountId).then(result => {
      return result.data;
    });
  }

  getPaiementProfileJSON(accountId): Promise<{ result: string; data: Array<IIkSelectPaymentPaiementProfileCard | IIkSelectPaymentPaiementProfilePrepaid> }> {
    const url = `/api/invoicing/${accountId}/payment_profile`;
    return this.http.get<{ result: string; data: Array<IIkSelectPaymentPaiementProfileCard | IIkSelectPaymentPaiementProfilePrepaid> }>(
      url,
    ).toPromise();
  }

  /**
 * Get billing adresses for account
 * @returns IPublicCloudBillingAddress[]
 */
  getBillingAdresses(accountId): Promise<IIkSelectPaymentBillingAddress[]> {
    return this.getBillingAdressesJSON(accountId).then(result => {
      return result.data;
    });
  }

  getBillingAdressesJSON(accountId): Promise<{ result: string; data: IIkSelectPaymentBillingAddress[] }> {
    const url = `/api/invoicing/${accountId}/addresses`;
    return this.http.get<{ result: string; data: IIkSelectPaymentBillingAddress[] }>(
      url,
    ).toPromise();
  }


}
